(ns client-portal.client.voice-commerce.orders.drawer.views
  "The order detail panel — the right-hand drawer a row click opens, registered as
   `:voice-commerce/order-panel` (see `client-portal.client.layout/panel-right-view`)
   and mirroring the sessions drawer."
  (:require [client-portal.client.layout :as l]
            [client-portal.client.voice-commerce.orders.data :as orders.d]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.components.components :as c]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.util :as util]))

(defn no-message-block [{:keys [message]}]
  [:div {:style {:display :flex
                 :align-items :center
                 :justify-content :center
                 :padding "30px 16px"
                 :height "100%"
                 :width "100%"}}
   [:span {:style {:font-size 13
                   :line-height 1.4
                   :font-weight 500
                   :color (style/alc-color "Text/secondary")
                   :text-align :center
                   :padding "16px"}}
    message]])

(defn ->order-detail [order]
  (if (or (nil? order) (util/loading? order))
    :loading
    @(re/subscribe [:voice-commerce/order-by-id- order])))

(defn header []
  (let [copied-link?* (re/ratom false)
        concept-id- (re/subscribe [:concepts/current-concept-id-])
        selected-order- (re/subscribe [:voice-commerce/selected-order-])]
    (fn []
      (let [selected-order @selected-order-]
        [:div {:style {:background-color (style/alc-color "Background/secondary")
                       :flex "0 0 auto"
                       :display :flex
                       :gap 8
                       :padding "12px 16px"
                       :position :sticky
                       :top 0
                       :min-height 58
                       :box-sizing :border-box
                       :z-index (inc (style/z :medium))}}
         [:span {:style {:color (style/alc-color "Text/primary_header")
                         :display :flex
                         :align-items :center
                         :font-size 20
                         :font-weight 400
                         :line-height 1.4}}
          "Order Detail"]
         [c/spacer]
         (when (:order-id selected-order)
           ^{:key (str "share-" @copied-link?*)}
           [alc/tooltip
            {:tooltip-content (if @copied-link?*
                                "Copied"
                                "Copy Order Link")
             :target-content [alc/up-ghost-button {:icon-type (if @copied-link?* :CheckCircleIcon :CopyIcon)
                                                   :on-click #(do
                                                                (re/dispatch [:core/copy-to-clipboard
                                                                              (orders.d/sharable-order-url
                                                                                @concept-id-
                                                                                selected-order)
                                                                              {:notify? false}])
                                                                (reset! copied-link?* true)
                                                                (util/wait 1500 (fn [] (reset! copied-link?* false))))}]}])
         [alc/up-button {:icon-type :CrossIcon
                         :rounded? true
                         :on-click #(re/dispatch [:voice-commerce/orders-toggle-drawer-open {:open? false}])}]]))))

(defn order-overview
  "The order's id, then its time flanked by the prev/next arrows — the same block the
   sessions drawer puts under its header."
  []
  (let [copied-order-id?* (re/ratom false)
        selected-order- (re/subscribe [:voice-commerce/selected-order-])
        orders- (re/subscribe [:voice-commerce/orders-list-flattened-])
        next-page-loading?- (re/subscribe [:voice-commerce/orders-list-next-page-loading?-])]
    (fn []
      (let [selected-order @selected-order-
            selected-order-idx (:order-idx selected-order)
            orders @orders-
            first? (= selected-order-idx 0)
            last? (when selected-order-idx
                    (>= selected-order-idx (dec (count orders))))
            order-id (:order-id selected-order)
            order-detail (->order-detail selected-order)
            occurred-at (:occurred-at (util/when-not-loading order-detail))
            loading? (util/loading? order-detail)]
        [:div {:style {:background-color (style/alc-color "Background/secondary")
                       :flex "0 0 auto"
                       :display :flex
                       :flex-direction :column
                       :align-items :center
                       :gap 4
                       :padding "12px 0"}}
         (when order-id
           ^{:key (str "order-id-" @copied-order-id?*)}
           [alc/tooltip
            {:tooltip-content (if @copied-order-id?*
                                "Copied"
                                "Copy Order ID")
             :target-content [c/interactive
                              :div {:on-click #(do
                                                 (re/dispatch [:core/copy-to-clipboard
                                                               order-id
                                                               {:notify? false}])
                                                 (reset! copied-order-id?* true)
                                                 (util/wait 1500 (fn [] (reset! copied-order-id?* false))))}
                              [:div {:style (cond-> {:color (style/alc-color "Text/secondary")
                                                     :display :flex
                                                     :align-items :center
                                                     :justify-content :center
                                                     :gap 9}
                                                    (not @copied-order-id?*)
                                                    (assoc :cursor :pointer))}
                               [:span {:style {:color :inherit
                                               :font-size 14
                                               :font-weight 400
                                               :line-height 1.43}}
                                order-id]
                               [c/material-icon {:icon-type (if @copied-order-id?*
                                                              :check-circle
                                                              :content-copy)
                                                 :style {:color (style/alc-color "Icons/secondary")
                                                         :font-size 14}}]]]}])
         [:div {:style {:display :flex
                        :align-items :center
                        :justify-content :space-between
                        :padding "0 16px"
                        :width "100%"}}
          (if selected-order-idx
            (if first?
              [:div {:style {:flex "0 0 36px"}}]
              [alc/up-ghost-button {:icon-type :ArrowLeftIcon
                                    :disabled @next-page-loading?-
                                    :on-click #(re/dispatch [:voice-commerce/orders-move-order :prev])}])
            [c/spacer])
          (cond
            loading?
            [:div {:style {:display :flex
                           :align-items :center
                           :padding "4px 0"}}
             [c/loader-rectangle {:height 28
                                  :width 160
                                  :style {:border-radius 8}}]]

            occurred-at
            [:div {:style {:display :flex
                           :align-items :center}}
             [:span {:style {:color (style/alc-color "Text/primary_header")
                             :font-size 20
                             :font-weight 400
                             :line-height 1.4}}
              occurred-at]])
          (if selected-order-idx
            (if (or (not last?) @next-page-loading?-)
              [alc/up-ghost-button {:icon-type :ArrowRightIcon
                                    :disabled @next-page-loading?-
                                    :on-click #(re/dispatch [:voice-commerce/orders-move-order :next])}]
              [:div {:style {:flex "0 0 36px"}}])
            [c/spacer])]]))))

(defmethod l/panel-right-view
  :voice-commerce/order-panel [_]
  (let [selected-order @(re/subscribe [:voice-commerce/selected-order-])
        order-detail (->order-detail selected-order)
        loading? (util/loading? order-detail)
        order (util/when-not-loading order-detail)]
    [:div {:id :order-drawer-scroll-container
           :style (cond-> {:overflow :auto}
                          loading?
                          (assoc :display :flex
                                 :flex-direction :column))}
     [header]
     [order-overview]
     (cond
       loading?
       [alc/up-loader-with-label {:label "Loading Order..."
                                  :style {:flex 1
                                          :height :auto
                                          :min-height :auto}}]

       ;; A 404 (or any failure) transforms to an empty map — the order the URL names
       ;; isn't there to show.
       (empty? order)
       [no-message-block {:message (str "No Order Found For \"" (:order-id selected-order) "\"")}]

       :else
       [:pre {:style {:color (style/alc-color "Text/primary")
                      :font-size 12
                      :line-height 1.5
                      :padding "16px"
                      :margin 0
                      :white-space :pre-wrap
                      :word-break :break-word}}
        (pr-str order)])]))
